import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IAvtalPrimaryKey } from "../avtal/AvtalCommandBase";

export class KontraktCommandBase extends BasicCommand<KontraktCommandBase> {
    readonly kontraktGuid;
    readonly avtalGuid;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Kontrakt";

    get primaryKey(): IKontraktPrimaryKey {
        return {
            avtalGuid: this.avtalGuid,
            kontraktGuid: this.kontraktGuid
        };
    }

    constructor(avtalGuid: string, kontraktGuid: string, type: string, commandType: CommandType) {
        super(type, KontraktCommandBase.$groupKey, commandType);
        this.kontraktGuid = kontraktGuid;
        this.avtalGuid = avtalGuid;
    }
}

export interface IKontraktPrimaryKey extends IAvtalPrimaryKey{
    kontraktGuid: string;
}
